module.exports = __webpack_public_path__ + "static/media/orcl-light-circular.4c2aac77.png";